module.exports = __webpack_public_path__ + "img/horizontal_7_5_pp3_7005.7677152d.png";